<div class="header-externo">
  <!-- Bloco da marca: mesma largura da barra lateral, para a borda dele cair em cima da
       borda do menu em vez de terminar no meio do conteúdo. -->
  <div class="header-marca">
    <button type="button" nbButton ghost size="small" status="control" class="btn-menu" (click)="toggleMenu()" aria-label="Abrir menu">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </button>
    <a class="logo-link" href="#" (click)="navigateHome($event)">
      <img src="assets/domus-data-logo.png?v=2" alt="DOMUS DATA" class="logo-img" />
    </a>
  </div>

  <div class="header-externo-direita">
    <button
      type="button"
      nbButton
      ghost
      status="control"
      class="btn-usuario"
      [nbContextMenu]="menuUsuario"
      nbContextMenuTag="menu-usuario"
      [attr.aria-label]="'Conta de ' + (nomeUsuario || 'usuário') + ' — abre o menu da conta: dados, troca de senha e saída'"
    >
      <nb-icon icon="person-outline"></nb-icon>
      <span class="ext-nome" *ngIf="nomeUsuario">{{ nomeUsuario }}</span>
      <nb-icon icon="chevron-down-outline" class="seta-usuario"></nb-icon>
    </button>
  </div>
</div>
